<script>
  import RetryPage from "../../../Shared/retryPage.svelte"
  import Progress from "../../../Shared/progress.svelte"
  import { push } from "svelte-spa-router"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {string} name of the start button based on conditions
   */
  export let startBtnName
  /**
   * @type {"start"|"processing"|"completed"|"retry"} active item in document status tab
   */
  export let activeDoc
  /**
   * @type {Number} width of the progress bar
   */
  export let width
</script>

{#if activeDoc == "start"}
  <div class="mt-6 flex w-full justify-center text-center text-base text-gray-400 mobile:w-3/4 md:w-1/2">
    {#if startBtnName == "Start"}
      <h1>To begin the process, click the start button for generating and uploading files. You can download the documents as image / pdf ZIP after completing the publishing process.</h1>
    {:else}
      <h1>To proceed with the procedure, select the "Resume" button to generate and upload the remaining files.</h1>
    {/if}
  </div>
  <div class="mt-6 flex gap-3">
    <button
      on:click={() => {
        dispatch("start")
      }}
      type="button"
      class="flex h-9 w-32 min-w-[36px] items-center {startBtnName == 'Start' ? 'bg-green-500 hover:bg-green-600 active:bg-green-500 disabled:bg-green-500/50' : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-500 disabled:bg-blue-500/50'} justify-center rounded-md border border-[#a0a1a580] px-2 text-sm font-medium text-white hover:text-white focus:outline-none disabled:cursor-not-allowed lg:px-4"
    >
      <span>
        <i class="fa-solid fa-circle-play" />
      </span>

      <span class="select-none">&nbsp;&nbsp;{startBtnName}&nbsp;</span>
    </button>
  </div>
{:else if activeDoc == "processing"}
  <Progress {width} content="File Generation in Progress" />
{:else if activeDoc == "completed"}
  <div class="mt-12 flex w-full items-center justify-center gap-3 text-center text-3xl font-bold text-green-500 mobile:w-4/5 lg:w-3/5">
    <i class="fa-solid fa-circle-check" />
    <h1 class="text-2xl">Process Completed</h1>
  </div>
  <div class="mt-6 flex w-full flex-col justify-center gap-3 text-center text-base text-gray-400 mobile:w-4/5 lg:w-3/5">
    <h1>The files have been successfully generated. If everything looks good, you can proceed to sign and publish.</h1>
    <h1 class="text-[#ff6a00]">You can download all the documents as a zip file after completing the publishing process.</h1>
  </div>
  <div class="mt-12 flex w-full flex-col justify-center gap-3 mobile:flex-row">
    <button
      on:click={() => {
        dispatch("preview")
      }}
      type="button"
      class="disabled:text-white-200/50 flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-200/50"
    >
      <span><i class="fa-solid fa-file" /></span>
      <span class="select-none">&nbsp;&nbsp;Preview&nbsp;Generated&nbsp;Documents&nbsp;</span>
    </button>
    <button on:click type="button" class="disabled:text-white-200/50 flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-4 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-200/50">
      <span><i class="fa-solid fa-upload" /></span>
      <span class="select-none">&nbsp;&nbsp;Sign&nbsp;and&nbsp;Publish&nbsp;</span>
    </button>
  </div>
{:else}
  <RetryPage content="A few documents encountered failures during the generation and uploading process. Please consider retrying to proceed." />
{/if}

<style global lang="postcss">
  .normal-blue-btn {
    @apply flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500;
  }
</style>
